import { ApiError } from '@/api/client'

export function getErrorMessage(
  error: unknown,
  fallback = 'Something went wrong. Please try again.',
): string {
  return error instanceof ApiError ? error.message : fallback
}

export function getFieldErrors(error: unknown): Record<string, string[]> | null {
  return error instanceof ApiError ? error.fieldErrors : null
}
